import React from "react";
import Table from "../../components/Table";
import { Column } from "../../components/BaseTable";
import { HuidigeSituatieWoonsituatie } from "../../../../.generated/rapportage/rapportagetypes";
import { formatDate, formatPercentage } from "../../../formatters";

export interface SingleWoonsituatieTableProps {
  data: HuidigeSituatieWoonsituatie;
}

export interface WoonsituatieTableProps {
  data: HuidigeSituatieWoonsituatie[];
}

export const SingleWoonsituatieTable: React.FC<SingleWoonsituatieTableProps> = ({
  data,
}: SingleWoonsituatieTableProps) => {
  const columns: Column<HuidigeSituatieWoonsituatie>[] = [
    {
      header: data.type ?? "",
      accessor: () => " ",
    },
    {
      header: "Adres",
      accessor: "adres",
    },
    {
      header: "Bewoner(s)",
      accessor: "bewoners",
    },
    {
      header: "Eigendomsverhouding",
      accessor: "eigendomsverhouding",
    },
    {
      header: "Gebruik woning",
      accessor: "gebruikWoning",
    },
    {
      header: "Aard onderpand",
      accessor: "aardOnderpand",
    },
    {
      header: "Energie label",
      accessor: "energieLabel",
    },
    {
      header: "Energie label einddatum",
      accessor: "energieLabelEinddatum",
      dataType: "date",
    },
    {
      header: "Marktwaarde",
      accessor: "marktwaarde",
      dataType: "currency",
    },
    {
      header: "WOZ-waarde",
      accessor: "wozWaarde",
      dataType: "currency",
    },
    {
      header: "Eigenwoningforfait",
      accessor: "eigenwoningforfait",
      dataType: "currency",
    },
    {
      header: "Verkoopstatus",
      accessor: "verkoopstatus",
    },
    {
      header: "Verkoopprijs",
      accessor: "verkoopprijs",
      dataType: "currency",
    },
    {
      header: "Verkoopkosten",
      accessor: "verkoopkosten",
      dataType: "currency",
    },
    {
      header: "Ontbindende voorwaarden tot",
      accessor: (row) => formatDate(row.ontbindendeVoorwaardenTot),
    },
    {
      header: "Huur per maand",
      accessor: "huurPerMaand",
      dataType: "currency",
    },
    {
      header: "Huurstijging per jaar",
      accessor: (row) => {
        if (!row.huurstijgingPerJaar) return null;
        return formatPercentage(row.huurstijgingPerJaar);
      },
    },
  ];

  return (
    <div className="mb-4">
      <Table
        columns={columns}
        data={[data]}
        rotate={true}
        showHeader={true}
        filterNullAnd0Columns={true}
        id={`woonsituatie-table-${data.type
          ?.replace(/\s+/g, "-")
          .toLowerCase()}`}
      />
    </div>
  );
};

export const WoonsituatieTable: React.FC<WoonsituatieTableProps> = ({
  data,
}: WoonsituatieTableProps) => {
  return (
    <div className="woonsituaties-section">
      {data.map((woonsituatie, index) => (
        <SingleWoonsituatieTable key={index} data={woonsituatie} />
      ))}
    </div>
  );
};
